<template>

    <div>
        <form class="myForm mt-5">
            <div class="form-group row">

                <label for="nome" class="col-sm-2 col-form-label">Número:<span class='text-danger'> *</span></label>
                <div class="col-sm-4">
                    <input type='text' class="form-control" v-model="numero">
                </div>
                <label for="nome" class="col-sm-2 col-form-label">Data Assinatura:<span
                        class='text-danger'> *</span></label>
                <div class="col-sm-4">
                    <datepicker
                            v-model="dtAssin"
                            :lang="lang"
                            format="DD/MM/YYYY"
                            @change="validaData('dtAssin')"
                    ></datepicker>
                </div>
            </div>

            <div class="form-group row">
                <label for="nome" class="col-sm-2 col-form-label">Objeto:</label>
                <div class="col-sm-4">
                    <textarea type="text" rows="3" class="form-control" v-model="objeto"></textarea>
                </div>
                <label for="nome" class="col-sm-2 col-form-label">Data Encerramento:</label>
                <div class="col-sm-4">
                    <datepicker
                            v-model="dtEncer"
                            :lang="lang"
                            format="DD/MM/YYYY"
                            @change="validaData('dtEncer')"
                    ></datepicker>
                </div>
            </div>
            <div class="form-group row">
                <label for="nome" class="col-sm-2 col-form-label">CNPJ Concedente:<span
                        class='text-danger'> *</span></label>
                <div class="col-sm-4">
                    <the-mask class="form-control" :mask="['##.###.###/####-##']" v-model="cnpjConv" required/>
                </div>
                <label for="nome" class="col-sm-2 col-form-label">Valor (R$):</label>
                <div class="col-sm-4">
                    <money class="form-control" v-bind="money" v-model="valor"></money>
                </div>
            </div>
            <div class="form-group row">
                <label for="nome" class="col-sm-2 col-form-label">Nome Concedente:</label>
                <div class="col-sm-4">
                    <input type="text" class="form-control" v-model="nomeConv">
                </div>
                <label for="nome" class="col-sm-2 col-form-label">Valor da Contra Partida (R$):</label>
                <div class="col-sm-4">
                    <money class="form-control" v-bind="money" v-model="contraPart"></money>
                </div>
            </div>
            <div class="form-group row">
                <label for="nome" class="col-sm-2 col-form-label">Fonte de Recurso: <span class='text-danger'> *</span></label>
                <div class="col-sm-4">
                    <input type="text" class="form-control" v-model="fonteRec" required>
                </div>
            </div>
        </form>
        <div class="container text-right mt-2">
            <button class="btn btn-sm btn-danger" @click="retorno">Retornar</button>
            <button class="btn btn-sm btn-success ml-2"
                    :disabled="(!numero != '' || !cnpjConv != '' || !fonteRec != '' || !dtAssin != '')" @click="salvar">
                Salvar
            </button>
        </div>
    </div>
</template>

<script>
    import Datepicker from 'vue2-datepicker'

    export default {
        name: 'TipoConveniosEditar',
        props: {
            id: Number
        },
        data() {
            return {
                numero: '',
                dtAssin: '',
                objeto: '',
                dtEncer: '',
                cnpjConv: '',
                valor: '',
                nomeConv: '',
                contraPart: '',
                fonteRec: '',
                money: {
                    decimal: ',',
                    thousands: '.',
                    prefix: 'R$ '
                },
                lang: {
                    days: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
                    months: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
                    pickers: ['próximos 7 dias', 'próximos 30 dias', '7 dias atrás', '30 dias atrás'],
                    placeholder: {
                        date: 'Selecione uma Data',
                        dateRange: 'Selecione um range de Datas'
                    }
                }
            }
        },
        components: {
            Datepicker
        },
        methods: {
            retorno() {
                this.$router.go(0)
            },
            validaData(dt) {
                let thisVue = this;
                if (this.dtAssin == '' || this.dtEncer == '')
                    return;
                if (this.dtAssin >= this.dtEncer) {
                    this.$swal(
                        'Atenção!',
                        'A data de encerramento deve ser maior que a data de assinatura',
                        'info'
                    ).then(function (resp) {
                        thisVue[dt] = '';
                    });
                }
            },
            formataData(dt) {
                return new Date(dt).toLocaleDateString('ko-KR', {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit'
                }).split('. ').join('-').replace('.', '');
            },
            salvar() {
                API.enviarRequisicao('put', '/api/sist-obras/convenios/' + this.id, {
                    c05_num: this.numero,
                    c05_objeto: this.objeto,
                    c05_convenente_cnpj: this.cnpjConv,
                    c05_convenente_nome: this.nomeConv,
                    c05_dt_assin: this.formataData(this.dtAssin),
                    c05_dt_fim: this.formataData(this.dtEncer),
                    c05_valor: this.valor,
                    c05_contra_part: this.contraPart,
                    c05_fonte_rec: this.fonteRec
                })
                    .then(response => {
                        this.$swal('', 'Dados salvos com sucesso.', 'success')
                            .then(
                                function () {
                                    history.go(0);
                                }
                            )
                    })
                    .catch(function (error) {
                        this.$swal('Atenção!', 'Erro ao cadastrar os dados.', 'info')
                    })

            }
        },
        mounted: function () {
            API.enviarRequisicao('get', '/api/sist-obras/convenios/' + this.id)
                .then(response => {
                    this.dados = response.data
                    this.numero = response.data.c05_num,
                    this.dtAssin = response.data.c05_dt_assin.replace('-', '/'),
                    this.objeto = response.data.c05_objeto,
                    this.dtEncer = response.data.c05_dt_fim.replace('-', '/'),
                    this.cnpjConv = response.data.c05_convenente_cnpj,
                    this.valor = response.data.c05_valor,
                    this.nomeConv = response.data.c05_convenente_nome,
                    this.contraPart = response.data.c05_contra_part,
                    this.fonteRec = response.data.c05_fonte_rec
                })
        }
    }
</script>

<style scoped>

    a {
        background-color: #18A689;
        color: #fff;
        font-size: 12px;
        text-decoration: none;
    }

    .mx-datepicker {
        width: 100%;
    }
</style>
